import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="referrals"
export default class extends Controller {

  acknowledge(e) {
    let controllerRef = this
    this.clearTooltips()
    e.preventDefault()
    var item = e.currentTarget
    $.ajax({
      type: "PATCH",
      url: "/members/" + item.dataset.id + "/acknowledge",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if(data.status == 200){
          var html = '<i class="bi bi-check-circle-fill text-success h4 pointer" data-bs-toggle="tooltip" data-bs-title="Unacknowledge Referral" data-id="' + item.dataset.id + '" data-action="click->referrals#unacknowledge"></i>'
          item.parentElement.innerHTML = html
          controllerRef.reloadTooltip()
        } else {
          alert('Error acknowledging referral. Please try again.')
        }
      }
    })
  }

  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  dealLost(e) {
    e.preventDefault()
    var item = e.currentTarget

    var ans = confirm("Are you sure you want to mark this deal lost?")
    if(ans){ 
      $.ajax({
        type: "PATCH",
        url: "/members/" + item.dataset.id + "/deal_lost",
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: function(data) {
          if(data.status == 200) {
            document.getElementById("acknowledge_" + data.id).innerHTML = ""
            document.getElementById("referral_content_" + data.id).innerHTML = "Referral has been moved to \"Deals Lost\" tab"
          } else {
            alert("Error saving deal status. Please try again.")
          }
        }
      })
    }

    this.clearTooltips()
  }

  dealWon(e) {
    e.preventDefault()
    var item = e.currentTarget

    $.ajax({
      type: "PATCH",
      url: item.action,
      data: {
        referral: { 
          deal_status: 1,
          deal_amount: $('#referral_deal_amount').val(),
          deal_closed: $('#referral_deal_closed').val()
        }
      },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById("acknowledge_" + data.id).innerHTML = ""
          document.getElementById("referral_content_" + data.id).innerHTML = "Referral has been moved to \"Deals Won\" tab"
          $('#close-modal-btn').click()
        } else {
          alert("Error saving deal status. Please try again.")
        }
      }
    })
  }

  reloadTooltip(){
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }


  unacknowledge(e) {
    let controllerRef = this
    this.clearTooltips()
    e.preventDefault()
    var item = e.currentTarget
    $.ajax({
      type: "PATCH",
      url: "/members/" + item.dataset.id + "/unacknowledge",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if(data.status == 200){
          var html = '<i class="bi bi-exclamation-circle text-info h4 pointer" data-bs-toggle="tooltip" data-bs-title="Acknowledge Referral" data-id="' + item.dataset.id + '" data-action="click->referrals#acknowledge"></i>'
          item.parentElement.innerHTML = html
          controllerRef.reloadTooltip()
        } else {
          alert('Error unacknowledgeing referral. Please try again.')
        }
      }
    })
  }
}
